import React from "react";

import { Route, Routes, useNavigate } from "react-router-dom";
import RequireRoles from "../../auth/RequireRoles";

import ModuleBrowser from "./browse/ModuleBrowser";
import ModuleEdit from "./edit/ModuleEdit";

const ModuleCreatorManagerView = () => {
  const navigate = useNavigate();

  const handleCancel = () => navigate(-1);

  return (
    <Routes>
      <Route
        index
        element={
          <RequireRoles
            roles={["ROLE_CREATOR_MANAGER"]}
            showUnauthorized={false}
          >
            <ModuleBrowser view="creatorManager" />
          </RequireRoles>
        }
      />
      <Route
        path=":id/*"
        element={
          <RequireRoles
            roles={["ROLE_CREATOR_MANAGER"]}
            showUnauthorized={false}
          >
            <ModuleEdit view="creatorManager" onCancel={handleCancel} />
          </RequireRoles>
        }
      />
    </Routes>
  );
};

export default ModuleCreatorManagerView;
